import { Button, Form, Input, InputNumber, Modal } from "antd";

const CreatePayoutModal = ({
  isModalOpen = false,
  setReferrerId = () => {},
  setIsModalOpen = () => {},
  maxAmount = 0,
  handleCreatePayout = () => {}
}) => {
  const [form] = Form.useForm();
  return (
    <Modal
      title="Create Payout To Referrer"
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setReferrerId("");
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setReferrerId("");
        setIsModalOpen(false);
      }}
    >
      <Form form={form} name="new_payout_form" onFinish={handleCreatePayout}>
        <Form.Item
          name="amount"
          label="Amount"
          rules={[
            {
              required: true,
              type: "number",
              min: 0,
              max: maxAmount,
              message: `Amount must be between 0 and ${maxAmount}`
            }
          ]}
        >
          <InputNumber style={{ width: "min(400px, 100%)" }} placeholder="3000" />
        </Form.Item>

        <Form.Item
          name="transactionId"
          label="TransactionId"
          rules={[
            {
              required: true,
              message: "Please enter the transaction ID!"
            }
          ]}
        >
          <Input
            prefix={<i className="fa fa-ship" aria-hidden="true" />}
            placeholder="123fdcgexxxxxxxx"
          />
        </Form.Item>
        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Create Payout
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreatePayoutModal;
